module.exports = __webpack_public_path__ + "img/sapem.ee27e5a6.png";